export default __webpack_public_path__ + "static/feature-l3-image-16b4537d115e9af44166697fff36cdeb.png";